/* eslint-disable react/no-unescaped-entities */
import { ReactElement } from "react";
import Head from "next/head";
import Image from "next/image";

import { MainLayout } from "@/containers/layout/LandingLayout";

const SurveyValuationFeeTermsOfUse = () => {
  return (
    <>
      <Head>
        <title>Survey and valuation fee terms of use | Keyzy</title>
        <meta
          name="description" key="description"
          content="Our terms of use set out how the survey and valuation fee works."
        />
      </Head>

      <div className="relative px-5 mt-10 mb-10 xl:mb-14 xl:mt-20">
        <div className="relative text-left mb-7 xl:h-32 xl:text-center">
          <div className="absolute hidden transform rotate-180 -left-10 -top-5 w-96 h-36 xl:inline-block">
            <Image
              src="/shared/shapes.svg"
              alt="shapes doodles"
              objectFit="contain"
              layout="fill"
              priority
            />
          </div>

          <h1 className="font-bold max-w-[52.75rem] mx-auto xl:max-w-none text-4xl xs:text-[44px] md:text-[56px] xs:leading-[46px] md:leading-[59px]">
            Terms and Conditions:
            <br />
            Keyzy Survey and Valuation Fee
            <br className="br-2x" />
            <br className="br-2x" />
          </h1>
          <br className="br-2x" />
          <div className="absolute hidden -right-10 -top-5 w-96 h-36 xl:inline-block">
            <Image
              src="/shared/shapes.svg"
              alt="shapes doodles 2"
              objectFit="contain"
              layout="fill"
              priority
            />
          </div>
        </div>

        <div className="flex flex-col max-w-[52.75rem] w-full mx-auto">
          <ol>
            <li className="mb-16">
              <p>
                These terms and conditions (“Agreement“) apply to the Keyzy survey and valuation fee
                (“Fee“) provided by Kollitom Ltd. (“Keyzy,“ “we,“ or “us“). By using the Fee, you
                (“you,“ “your,“ or “customer“) agree to be bound by this Agreement.
              </p>
            </li>

            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">1. Service Description</h2>
              <p>
                The Fee covers the expenses of property surveys, specialist surveys, and property
                valuations. Once an offer has been accepted on the home, you will be presented with
                an updated quote for your Keyzy deal. In order to continue with the purchase of the
                home, you will need to accept this updated quote and pay the Fee. The Fee is charged
                to a customer once an offer has been accepted on a property.
              </p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">2. Payment Terms</h2>
              <p>Payment of the Fee is due upon acceptance of your Keyzy quote.</p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">3. VAT</h2>
              <p>
                The Survey and Valuation Fee referred to in these terms and conditions is inclusive
                of Value Added Tax (”VAT”).
              </p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">4. Services Provided</h2>
              <p>
                The Fee covers expenses relating to Keyzy commissioning a surveyor to conduct a RICS
                Level 2 Homebuyers report on the condition of the chosen property, a valuation
                report on the estimated value and reinstatement value of the property, specialist
                inspection and reports on Gas and Electrical safety, further specialist reports if
                deemed necessary such as damp and timber or roof structure, and a report summary
                call with you to review the issues highlighted in the reports.
              </p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">5. Transferable Fee</h2>
              <p>
                Under certain circumstances, if the sale on the property collapses this Fee will not
                be charged to the customer again and, in effect, be transferable to cover the
                Service on their next property. This will only happen if either the seller pulls out
                of the transaction, or Keyzy decides not to continue the purchase for any reason.
                However, if the customer pulls out of the transaction, the Fee cannot be transferred
                to a new property and would need to be paid again in full if they want to proceed on
                a new transaction.
              </p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">6. Liability</h2>
              <p>
                Keyzy is not responsible for any loss or damage that you may incur as a result of
                using the Fee, except to the extent that such loss or damage is caused by Keyzy's
                negligence. Keyzy's liability to you is limited to the amount of the Fee.
              </p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">7. Governing Law</h2>
              <p>
                This Agreement is governed by and construed in accordance with the laws of England
                and Wales. Any disputes arising out of or in connection with this Agreement will be
                resolved exclusively by the courts of England and Wales.
              </p>
            </li>
            <li className="mb-14">
              <h2 className="mb-5 text-xl font-bold mt-7">8. Entire Agreement</h2>
              <p>
                This Agreement constitutes the entire agreement between you and Keyzy regarding the
                Fee and supersedes all prior agreements and understandings, whether written or oral.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

SurveyValuationFeeTermsOfUse.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout theme="light">{page}</MainLayout>;
};

export default SurveyValuationFeeTermsOfUse;
